import React, { Component } from "react";
import HeaderNew from "./HeaderNew";
import FooterNew from "./FooterNew";
import Footer from "../Copyrights/Footer";
import BackArrow from "./../../../public/assets/images/back-arrow-dark.svg";
import Chart from "./../../../public/assets/images/chart-image.png";
import MiniArrow from "./../../../public/assets/images/mini-arrow.svg"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//import { Scrollbar } from 'react-scrollbars-custom';

import $ from 'jquery';
import { getPlan } from '../../API/FetchCall';

var CurrencyFormat = require('react-currency-format');

import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';
import ModalHeader from 'reactstrap/lib/ModalHeader';

import { Helmet } from 'react-helmet';

const benefits = [<ul><li>200-word write-up about yourself and services offered on your page.</li>
  <li>Manage your profile page frequently to improve brand and visibility.</li>
  <li>Upload up to 8 images on your profile page.</li>
  <li>Post your social media link(s) on your page.</li>
  <li>Email interaction with prospective parents.</li>
  <li>Respond to users on their feedback.</li>
  <li>Upload videos links to showcase excellence.</li>
  <li>Publish two articles a year on thought leadership.</li>
</ul>, <ul>
  <li>400-word write-up about yourself and services offered on your page.</li>
  <li>Manage your profile page frequently to improve brand and visibility.</li>
  <li>Upload up to 15 images on your profile page.</li>
  <li>Post your social media link(s) on your page.</li>
  <li>Drive showcase you in some of our social media.</li>
  <li>Email interaction with prospective parents.</li>
  <li>Upload videos links to showcase excellence.</li>
  <li>Publish two articles a year on thought leadership.</li>
</ul>];

class NewPartnerInstitutionPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plan_list2: [],
      current_plan: [],
      istabmoved:false,
      schoolpreschoolselected:true,
      isMagicPriceClikedView:false,
      isMagicWcPriceClikedView:false,
      isValuePriceClikedView:false,
      isStandardPriceClikedView1:false,
      isStandardPriceClikedView2:false,
    };
     
    this.getPlanList();

    this.type = this.props.match.params.type;

    this.slideCustom = React.createRef();
    this.slidepackages = React.createRef();
    this.slideCustom3 = React.createRef();
    this.openTab1 = this.openTab1.bind(this);
    this.openTab2 = this.openTab2.bind(this);
    this.showValuePrice = this.showValuePrice.bind(this);
    this.showMagicPrice = this.showMagicPrice.bind(this);
    this.showMagicWcPrice = this.showMagicWcPrice.bind(this);
  }

  componentDidMount() {

        if(this.type=='other')
         this.openTab2();
        else
        this.openTab1();


        var table = document.querySelector('.__table');

        var parents = table.querySelector('.onclick_expcol');
        console.clear();
        parents.addEventListener('click', el => {

             $(".onclick_expcol").html(($('.onclick_expcol').html() == '<img src="/images/chevron-up.svg">' ? '<img src="/images/chevron-down.svg">' : '<img src="/images/chevron-up.svg">'));

            $(".child").toggleClass('hidden');
            /*
            var classname = parents.getAttribute("data-child");
            var children = document.querySelector('.' + classname);
            children.forEach(c => {
              if (c.className.search("hidden") > -1) {
                c.className = c.className.replace("hidden", " ");
              } else {
                c.className = c.className + ' hidden';
              }
            });
            */
        });

  }

  showValuePrice = () => {
      this.setState({isValuePriceClikedView:true});
  }

  showMagicPrice = () => {
    this.setState({isMagicPriceClikedView:true});
}


  showStandardPrice1 = () => {
    this.setState({isStandardPriceClikedView1:true});
  }

  showStandardPrice2 = () => {
  this.setState({isStandardPriceClikedView2:true});
  }
  

  showMagicWcPrice = () => {
      this.setState({isMagicWcPriceClikedView:true});
  }

 

  openTab1 = () => {
    this.setState({schoolpreschoolselected:true, otherselected:false});
    $("#tab1").addClass('active');
    $("#tab2").removeClass('active');
    $(".tabby-content-1").removeClass('hidden');
    $(".tabby-content-2").addClass('hidden');
    $(".tabby-content-1").css('opacity', '1.0');
  }


  openTab2 = () => {
    this.setState({otherselected:true,schoolpreschoolselected:false});
    $("#tab2").addClass('active');
    $("#tab1").removeClass('active');
    $(".tabby-content-1").addClass('hidden');
    $(".tabby-content-2").removeClass('hidden');
    $(".tabby-content-2").css('opacity', '1.0');
  }


  getPlanList = async () => {
    let planData = JSON.stringify({
      user_type: 1,
    });

    getPlan(planData).then((response) => {
      if (response.status == 1) {
        this.setState({
          plan_list2: response.results,
        });

      } else {
        console.log('else')
      }
    });
  }

  handlePlan = (id) => {
    let plan_info = this.state.plan_list2.filter(o => o.id == id);
    console.log('plan_info', plan_info)
    this.setState({
      current_plan: plan_info,
      plan_id: id,
      offerModal: true,
      analyticsModal: false,
    });
    setTimeout(function () {
      $(".modal").addClass("in");
    }, 500);
  };


  analyticsOffer = () => {
    this.setState({
      offerModal: false,
      analyticsModal: true,
    });
    setTimeout(function () {
      $(".modal").addClass("in");
    }, 500);
  };
  backToOffer = () => {
    this.setState({
      offerModal: true,
      analyticsModal: false,
    });
    setTimeout(function () {
      $(".modal").addClass("in");
    }, 500);
  };
  backToSlide = () => {
    this.setState({
      offerModal: false,
      analyticsModal: false,
    });
    setTimeout(function () {
      $(".modal").removeClass("in");
    }, 500);
  };


  render() {


    var settings = {
      dots: false,
      infinite: false,
      speed: 2000,
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay: false,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]

    };

    var plan_settings = {

      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]

    };

    
    var settings_partners = {

      dots: true,
      infinite: true,
      speed: 2000,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: false,
      autoplaySpeed: 3000,
      arrows:true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]

    };

    var settings_dashboards = {

      dots: true,
      infinite: false,
      speed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]

    };

 

    return (
      <React.Fragment>

        <Helmet>
        <title>BeWise Partners Plans- Enhancing Education Together</title>
        <meta name="description" content={'Collaborate with us to access customized solutions for the growth of your institution with Bewise. Explore our custom plans that elevate learning and drive success.'} />
        </Helmet>

        <HeaderNew 
              schoolpreschoolselected={this.state.schoolpreschoolselected} 
              otherselected={this.state.otherselected} 
              toggleOpenTab1={this.openTab1}
              toggleOpenTab2={this.openTab2}      
        />

       

        <div class="row display-flex-center mainrowheader" style={{ marginTop: "85px" }} >



          <div class="col-lg-12 col-sm-12 col-md-12 partnerpricepage">

                  { /* <div class="mainhead">Our sole objective is to accelerate your Success / Growth! </div> removed Single partner page development 24 Aug 2023*/ }

                  <div class="mainpara">
                    Welcome to BeWise partner portal, your gateway to <b>growth and success!</b> Explore and choose amongst the many value-driven and tailor made opportunities that elevate your journey towards success, and one where every click or interaction opens fresh horizons of progress
                  </div>


                  

                  <div class="maincontent">



                  <div class="howitworksection">

<div class="become_text bolder">Become a BeWise partner in just <span>3 Steps</span></div>

<div class="threestepboxes desktop">

        <div class="stepperbox">

                    <img src="/images/box1.png"></img>
                    <div>
                        <div class="he1">Sign up</div>
                        <div class="he2">Login and complete verifications</div>
                    </div>  
        </div>
        <div class="stepperbox">
                    <img src="/images/box2.png"></img>
                    <div>
                        <div class="he1">Create and Complete Profile</div>
                        <div class="he2">Update your organisation details</div>
                    </div>  
        </div>

        <div class="stepperbox">
                    <img src="/images/box3.png"></img>
                    <div>
                        <div class="he1">Activate</div>
                        <div class="he2">Choose your options & enjoy the benefits</div>
                    </div>  
        </div>


</div>

<div class="threestepboxes mobile">
<Slider {...settings_dashboards}>

          <div class="stepperbox">

                      <img src="/images/box1.png"></img>
                      <div>
                          <div class="he1">Sign up</div>
                          <div class="he2">Login and complete verifications</div>
                      </div>  
          </div>
          <div class="stepperbox">
                      <img src="/images/box2.png"></img>
                      <div>
                          <div class="he1">Create and Complete Profile</div>
                          <div class="he2">Update your organisation details</div>
                      </div>  
          </div>

          <div class="stepperbox">
                      <img src="/images/box3.png"></img>
                      <div>
                          <div class="he1">Activate</div>
                          <div class="he2">Choose your options & enjoy the benefits</div>
                      </div>  
          </div>
</Slider>
</div>


</div>

                   <div class="chooseyour">Choose your <span>business context!</span></div>
                   <div class="tabs">
                        <div class="tabby-tab">
                          <input type="radio" id="tab-2" name="tabby-tabs" checked />
                          <label id="tab1" for="tab-2" onClick={this.openTab1}><span>Schools & Pre-Schools</span></label>
                           
                        </div>

                        <div class="tabby-tab">
                          <input type="radio" id="tab-3" name="tabby-tabs" />
                          <label id="tab2" for="tab-3" onClick={this.openTab2}><span>All Others</span></label>
                        
                        </div>
                  </div>


                  <div class="tabc tabby-content-1"  >
                           
                                <div class="chooseyour benefitstitle">Your Benefits</div>

                                <div class="desktop">
                                <div class="flexrow">
                                        <div class="bgflower"><img src="https://partner.bewise.in/images/flower.png" /></div>
                                        <div class="rowheadtitle">
                                            <div class="rtitle">Engagement</div>
                                            <div class="rpara">

                                            <ul class="rparalist">
                                            <li>24x 7 Digital presence and trust amongst target audience </li>

                                            <li>Maximise brand recall amongst prospects / talent</li> 

                                            <li>Directly receive leads and enquiries @ platform </li>

                                            <li>Effective & Improved Interaction with all parent community </li>

                                            <li>Attract & interact directly with top talent </li>

                                            </ul>  
                                                                                        
                                            </div>
                                        </div>

                                        <div class="rowheadshowimg">
                                              <div class="showimg"><img src="https://partner.bewise.in/images/excellendex.png" /></div>
                                        </div>
                                </div>

                                <div class="flexrow">
                                        <div class="bgflower rightside"><img src="https://partner.bewise.in/images/flower.png" /></div>
                                       

                                        <div class="rowheadshowimg">
                                              <div class="showimg"><img src="https://partner.bewise.in/images/enga_graph_1.png" /></div>
                                        </div>

                                        <div class="rowheadtitle">
                                            <div class="rtitle">Excellence</div>
                                            <div class="rpara">
                                              <ul class="rparalist">

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Data led insights, reports & comparison with peers to accelerate growth</li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Benchmarking Vs institutions - to enable your strategic options. </li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Maximise quality reviews, ratings, and response time for parents </li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Drive / create thought leadership to impact your brand. </li>
                                              
                                              </ul>  

                                            </div>
                                        </div>
                                </div>

                                <div class="flexrow">
                                        
                                      <div class="rowheadtitle">
                                            <div class="rtitle">Efficiency </div>
                                            <div class="rpara">
                                              <ul class="rparalist">

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" />Higher Growth, ROI & Savings on spends.</li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" />Explore benefits & scholarships from curated partners for your institution. </li> 

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" />Evolutionary / new collaborations to grow brand value & earnings!</li> 

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" />Choose & follow institutions you benchmark with for free.</li>

                                              
                                              </ul>  

                                            </div>
                                        </div>

                                        <div class="rowheadshowimg">
                                              <div class="showimg"><img src="https://partner.bewise.in/images/enga_graph_2.png" /></div>
                                        </div>

                                        
                                </div>


                                <div class="flexrow">
                                        <div class="bgflower rightside"><img src="https://partner.bewise.in/images/flower.png" /></div>
                                       

                                        <div class="rowheadshowimg">
                                              <div class="showimg"><img src="https://partner.bewise.in/images/rocket.png" /></div>
                                        </div>

                                        <div class="rowheadtitle">
                                            <div class="rtitle">Elevate</div>
                                            <div class="rpara">
                                              <ul class="rparalist">

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Explore best suited options to upskill yourself & team @ WiseConnect </li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Explore need based outsourcing & advisory services. </li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Frequently showcase success of your institution to target audience (Yourself & team for individuals)  </li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Create followers well in advance of turning them into prospects.  </li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Increase Brand visibility & presence by active participation @ Portal    </li> 
                                              </ul>  

                                            </div>
                                        </div>
                                </div>
                                </div>

                                <div class="mobile">
                                <div class="flexrow">
                                        <div class="bgflower"><img src="https://partner.bewise.in/images/flower.png" /></div>
                                        <div class="rowheadtitle">
                                            <div class="rtitle">Engagement</div>
                                            <div class="rowheadshowimg">
                                                <div class="showimg"><img src="https://partner.bewise.in/images/excellendex.png" /></div>
                                            </div>

                                            <div class="rpara">

                                            <ul class="rparalist">
                                            <li>24x 7 Digital presence and trust amongst target audience </li>

                                            <li>Maximise brand recall amongst prospects / talent</li> 

                                            <li>Directly receive leads and enquiries @ platform </li>

                                            <li>Effective & Improved Interaction with all parent community </li>

                                            <li>Attract & interact directly with top talent </li>

                                            </ul>  
                                                                                        
                                            </div>
                                        </div>

                                        
                                </div>

                                <div class="flexrow">
                                        <div class="bgflower rightside"><img src="https://partner.bewise.in/images/flower.png" /></div>
                                       

                                        

                                        <div class="rowheadtitle">
                                            <div class="rtitle">Excellence</div>
                                            <div class="rowheadshowimg">
                                              <div class="showimg"><img src="https://partner.bewise.in/images/enga_graph_1.png" /></div>
                                            </div>
                                            <div class="rpara">
                                              <ul class="rparalist">

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Data led insights, reports & comparison with peers to accelerate growth</li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Benchmarking Vs institutions - to enable your strategic options. </li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Maximise quality reviews, ratings, and response time for parents </li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Drive / create thought leadership to impact your brand. </li>
                                              
                                              </ul>  

                                            </div>
                                        </div>
                                </div>

                                <div class="flexrow">
                                        
                                      <div class="rowheadtitle">
                                            <div class="rtitle">Efficiency </div>
                                            <div class="rowheadshowimg">
                                              <div class="showimg"><img src="https://partner.bewise.in/images/enga_graph_2.png" /></div>
                                            </div>
                                            <div class="rpara">
                                              <ul class="rparalist">

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" />Higher Growth, ROI & Savings on spends.</li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" />Explore benefits & scholarships from curated partners for your institution. </li> 

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" />Evolutionary / new collaborations to grow brand value & earnings!</li> 

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" />Choose & follow institutions you benchmark with for free.</li>

                                              
                                              </ul>  

                                            </div>
                                        </div>

                                        

                                        
                                </div>


                                <div class="flexrow">
                                        <div class="bgflower rightside"><img src="https://partner.bewise.in/images/flower.png" /></div>
                                       
                                        <div class="rowheadtitle">
                                            <div class="rtitle">Elevate</div>
                                            <div class="rowheadshowimg">
                                              <div class="showimg"><img src="https://partner.bewise.in/images/rocket.png" /></div>
                                            </div>
                                            <div class="rpara">
                                              <ul class="rparalist">

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Explore best suited options to upskill yourself & team @ WiseConnect </li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Explore need based outsourcing & advisory services. </li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Frequently showcase success of your institution to target audience (Yourself & team for individuals)  </li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Create followers well in advance of turning them into prospects.  </li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Increase Brand visibility & presence by active participation @ Portal    </li> 
                                              </ul>  

                                            </div>
                                        </div>
                                </div>
                                </div>


                  </div>


                  <div class="tabc tabby-content-2 hidden">


                        <div class="chooseyour benefitstitle">Your Benefits</div>

                                <div class="desktop">
                                <div class="flexrow">
                                        <div class="bgflower"><img src="https://partner.bewise.in/images/flower.png" /></div>
                                        <div class="rowheadtitle">
                                            <div class="rtitle">Engagement</div>
                                            <div class="rpara">

                                            <ul class="rparalist">
                                            <li>24x 7 Digital presence and trust amongst target audience </li>

                                            <li>Maximise brand recall amongst prospects / talent</li> 

                                            <li>Directly receive leads and enquiries @ platform </li>

                                            <li>Effective & Improved Interaction with all parent community </li>

                                          
                                            </ul>  
                                                                                        
                                            </div>
                                        </div>

                                        <div class="rowheadshowimg">
                                              <div class="showimg"><img src="https://partner.bewise.in/images/excellendex.png" /></div>
                                        </div>
                                </div>

                                <div class="flexrow">
                                        <div class="bgflower rightside"><img src="https://partner.bewise.in/images/flower.png" /></div>
                                       

                                        <div class="rowheadshowimg">
                                              <div class="showimg"><img src="https://partner.bewise.in/images/enga_graph_1.png" /></div>
                                        </div>

                                        <div class="rowheadtitle">
                                            <div class="rtitle">Excellence</div>
                                            <div class="rpara">
                                              <ul class="rparalist">

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Data led insights, reports & comparison with peers to accelerate growth</li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Benchmarking Vs institutions - to enable your strategic options. </li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Maximise quality reviews, ratings, and response time for parents </li>

                                              <li><img src="https://partner.bewise.in/images/check-mark.png" /> Drive / create thought leadership to impact your brand. </li>
                                              
                                              </ul>  

                                            </div>
                                        </div>
                                </div>

                                <div class="flexrow">
                                        
                                      <div class="rowheadtitle">
                                            <div class="rtitle">Efficiency </div>
                                            <div class="rpara">
                                              <ul class="rparalist">

                                              <li><img src="images/check-mark.png" />Higher Growth, ROI & Savings on spends.</li>

                                              <li><img src="images/check-mark.png" />Explore benefits & scholarships from curated partners for your institution. </li> 

                                              <li><img src="images/check-mark.png" />Evolutionary / new collaborations to grow brand value & earnings!</li> 

                                              <li><img src="images/check-mark.png" />Choose & follow institutions you benchmark with for free.</li>

                                              
                                              </ul>  

                                            </div>
                                        </div>

                                        <div class="rowheadshowimg">
                                              <div class="showimg"><img src="/images/enga_graph_2.png" /></div>
                                        </div>

                                        
                                </div>


                                <div class="flexrow">
                                        <div class="bgflower rightside"><img src="/images/flower.png" /></div>
                                       

                                        <div class="rowheadshowimg">
                                              <div class="showimg"><img src="/images/rocket.png" /></div>
                                        </div>

                                        <div class="rowheadtitle">
                                            <div class="rtitle">Elevate</div>
                                            <div class="rpara">
                                              <ul class="rparalist">

                                              <li><img src="images/check-mark.png" /> Explore best suited options to upskill yourself & team @ WiseConnect </li>
                                             
                                              <li><img src="images/check-mark.png" /> Frequently showcase success of your institution to target audience (Yourself & team for individuals)  </li>

                                              <li><img src="images/check-mark.png" /> Create followers well in advance of turning them into prospects.  </li>

                                              <li><img src="images/check-mark.png" /> Increase Brand visibility & presence by active participation @ Portal  </li>

                                              </ul>  

                                            </div>
                                        </div>
                                </div>
                                </div>

                                <div class="mobile">
                                <div class="flexrow">
                                        <div class="bgflower"><img src="/images/flower.png" /></div>
                                        <div class="rowheadtitle">
                                            <div class="rtitle">Engagement</div>
                                            <div class="rowheadshowimg">
                                                <div class="showimg"><img src="/images/excellendex.png" /></div>
                                            </div>

                                            <div class="rpara">

                                            <ul class="rparalist">
                                            
                                            <li>24x 7 Digital presence and trust amongst target audience </li>

                                            <li>Maximise brand recall amongst prospects / talent</li> 

                                            <li>Directly receive leads and enquiries @ platform </li>

                                            <li>Effective & Improved Interaction with all parent community </li>

                                            </ul>  
                                                                                        
                                            </div>
                                        </div>

                                        
                                </div>

                                <div class="flexrow">
                                        <div class="bgflower rightside"><img src="/images/flower.png" /></div>
                                       

                                        

                                        <div class="rowheadtitle">
                                            <div class="rtitle">Excellence</div>
                                            <div class="rowheadshowimg">
                                              <div class="showimg"><img src="/images/enga_graph_1.png" /></div>
                                            </div>
                                            <div class="rpara">
                                              <ul class="rparalist">

                                              <li><img src="images/check-mark.png" /> Data led insights, reports & comparison with peers to accelerate growth</li>

                                              <li><img src="images/check-mark.png" /> Benchmarking Vs institutions - to enable your strategic options. </li>

                                              <li><img src="images/check-mark.png" /> Maximise quality reviews, ratings, and response time for parents </li>

                                              <li><img src="images/check-mark.png" /> Drive / create thought leadership to impact your brand. </li>
                                              
                                              </ul>  

                                            </div>
                                        </div>
                                </div>

                                <div class="flexrow">
                                        
                                      <div class="rowheadtitle">
                                            <div class="rtitle">Efficiency </div>
                                            <div class="rowheadshowimg">
                                              <div class="showimg"><img src="/images/enga_graph_2.png" /></div>
                                            </div>
                                            <div class="rpara">
                                              <ul class="rparalist">

                                              <li><img src="images/check-mark.png" />Higher Growth, ROI & Savings on spends.</li>

                                              <li><img src="images/check-mark.png" />Explore benefits & scholarships from curated partners for your institution. </li> 

                                              <li><img src="images/check-mark.png" />Evolutionary / new collaborations to grow brand value & earnings!</li> 

                                              <li><img src="images/check-mark.png" />Choose & follow institutions you benchmark with for free.</li>

                                              
                                              </ul>  

                                            </div>
                                        </div>

                                        

                                        
                                </div>


                                <div class="flexrow">
                                        <div class="bgflower rightside"><img src="/images/flower.png" /></div>
                                       
                                        <div class="rowheadtitle">
                                            <div class="rtitle">Elevate</div>
                                            <div class="rowheadshowimg">
                                              <div class="showimg"><img src="/images/rocket.png" /></div>
                                            </div>
                                            <div class="rpara">
                                              <ul class="rparalist">

                                              <li><img src="images/check-mark.png" /> Explore best suited options to upskill yourself & team @ WiseConnect </li>

                                              <li><img src="images/check-mark.png" /> Frequently showcase success of your institution to target audience (Yourself & team for individuals)  </li>

                                              <li><img src="images/check-mark.png" /> Create followers well in advance of turning them into prospects.  </li>

                                              <li><img src="images/check-mark.png" /> Increase Brand visibility & presence by active participation @ Portal    </li> 
                                              </ul>  

                                            </div>
                                        </div>
                                </div>
                                </div>   
                                                  
                           
                  </div>

            </div>

          </div>
         

        

           <div class="col-lg-12 col-sm-12">
           <div class="slider70width benefitsfromourpartners">

                     <div class="sectionboldtitle">Benefit from our curated partners</div>

                     <Slider {...settings_partners}>

                             <div class="sliderbgpadded slider_partners">
                                 <img src="/images/sliders/partners/slider_1.png" />
                             </div>

                             <div class="sliderbgpadded slider_partners">
                                 <img src="/images/sliders/partners/slider_2.png" />
                             </div>

                             <div class="sliderbgpadded slider_partners">
                                 <img src="/images/sliders/partners/slider_3.png" />
                             </div>

                             <div class="sliderbgpadded slider_partners">
                                 <img src="/images/sliders/partners/slider_4.png" />
                             </div>

                             <div class="sliderbgpadded slider_partners">
                                 <img src="/images/sliders/partners/slider_5.png" />
                             </div>

                             <div class="sliderbgpadded slider_partners">
                                 <img src="/images/sliders/partners/slider_6.png" />
                             </div>
                       
                     </Slider>
           </div>
           </div>




          <div class="col-lg-12 col-sm-12">
                    <div class="sliderfullwidth">

                              <div class="slider_text">Access all important metrics with our <span>comprehensive dashboard</span></div>

                              <Slider {...settings_dashboards}>

                                      <div class="sliderbgpadded">
                                          <img src="/images/sliders/slider_1.png" />
                                      </div>

                                      <div class="sliderbgpadded">
                                          <img src="/images/sliders/slider_2.png" />
                                      </div>

                                      <div class="sliderbgpadded">
                                          <img src="/images/sliders/slider_3.png" />
                                      </div>
                                
                              </Slider>
                    </div>
          </div>


          <div class="col-lg-12 col-sm-12 yelbg" style={{backgroundImage:`url('/images/yelloartline.png')`}}>

              <div class="new_plan_section mobileonly">

              <div class="colored_centered">Get <span>Started</span></div>

              {this.state.schoolpreschoolselected &&
                <div>
                  <div class="newpricing">

                      <div class="fixedbar">
                            <div class="headofit">
                              <div class="flx planfeatures">Features</div>
                              <div class="flx plantitle magic">Magic</div>
                              <div class="flx plantitle standard ">Standard</div>
                            </div>
                      </div>
                      
                      <div class="scrollingview">

                              <div class="bodyofit">

                                    <div class="flxblack featureitem">24x 7 visibility for Target Audience with:</div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>

                              </div>
                              <div class="bodyofit">

                                    <div class="flxblack featureitem">Professional  digital presence</div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    
                              </div>

                              <div class="bodyofit">

                                    <div class="flxblack featureitem">Post your Ad in landing page</div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                                    
                              </div>

                              <div class="bodyofit">

                                    <div class="flxblack featureitem">Visiblity and respond to review / ratings </div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                                    
                              </div>

                              <div class="bodyofit">

                                    <div class="flxblack featureitem">Upload Pictures on page</div>
                                    <div class="flxblack planstatus"><span>3 Free</span></div>
                                    <div class="flxblack planstatus"><span>Upto 15</span></div>
                                    
                              </div>

                              <div class="bodyofit">

                                    <div class="flxblack featureitem">Upload video on page</div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                                    
                              </div>

                              <div class="bodyofit">

                                    <div class="flxblack featureitem">Direct interaction with parents </div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                                    
                              </div>


                              <div class="bodyofit">

                              <div class="flxblack featureitem">Featured in Trending Now</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>

                              </div>

                              <div class="bodyofit">

                              <div class="flxblack featureitem">Collaborative social media support</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>

                              </div>

                              <div class="bodyofit">

                              <div class="flxblack featureitem">Verified partner stamp </div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>

                              </div>
                              <div class="bodyofit">

                              <div class="flxblack featureitem">Receive Leads & enquires</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>

                              </div>          

                              <div class="bodyofit">
                              <div class="flxblack featureitem">Benchmark to your peers / competitors </div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                              </div>          
                              <div class="bodyofit">
                              <div class="flxblack featureitem">Build your brand & thought leadership.</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                              </div>          
                              <div class="bodyofit">
                              <div class="flxblack featureitem">Ads & newsletter promotion @ special prices</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                              </div>          
                              <div class="bodyofit">
                              <div class="flxblack featureitem">Free benefits of INR 50K+ + from curated partner support</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                              </div>          
                              <div class="bodyofit">
                              <div class="flxblack featureitem">Scope for collaborative & customised services</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                              </div>  

                              <div class="bodyofit">
                              <div class="flxblack featureitem">Pricing & benefits @ WiseConnect</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                              </div> 

                              <div class="bodyofit">
                              <div class="flxblack featureitem">Data & analytics to accelerate growth</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span>Partly Free</span></div>
                              </div> 

                              <div class="bodyofit">
                              <div class="flxblack featureitem">Access to Skill building / self-development </div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span>Partly Free</span></div>
                              </div> 

                              <div class="bodyofit">
                              <div class="flxblack featureitem"> <div class="flxblack featureitem">*BeWise annual subscription only</div></div>
                              <div class="flxblack planstatus">
                                  <div class="viewpricing">
                                        {this.state.isMagicPriceClikedView &&
                                        <div><span class="stricked">Rs. 29999</span><span>Rs. 24999/-</span></div>
                                        }
                                        {!this.state.isMagicPriceClikedView &&
                                        <span onClick={this.showMagicPrice}>view price</span>
                                        }
                                </div>
                              </div>
                              <div class="flxblack planstatus">FREE</div>
                              </div>         

                      </div>
                       

                  </div>    

                  <div class="colored_centered"> <a href="/institution_signup"  class="btn new-btn-blue-large">Sign Up Now!</a> </div>
                </div>
              }

              {this.state.otherselected &&
                <div>
                <div class="newpricing">

                    <div class="fixedbar">
                      <div class="headofit">
                        <div class="flx planfeatures">Features</div>
                        <div class="flx plantitle magic">Value</div>
                        <div class="flx plantitle standard ">Standard</div>
                      </div>
                    </div>
                     
                      <div class="scrollingview">

                              <div class="bodyofit">

                                    <div class="flxblack featureitem">24x 7 visibility for Target Audience with</div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>

                              </div>
                              <div class="bodyofit">

                                    <div class="flxblack featureitem">Professional  digital presence</div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    
                              </div>

                              <div class="bodyofit">

                                    <div class="flxblack featureitem">Visiblity and respond to review / ratings </div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                                    
                              </div>

                              <div class="bodyofit">

                                    <div class="flxblack featureitem">Use page as own Web Page in marketing</div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                                    
                              </div>

                              <div class="bodyofit">

                                    <div class="flxblack featureitem">Upload Pictures on page</div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                                    
                              </div>

                              <div class="bodyofit">

                                    <div class="flxblack featureitem">Upload video on page</div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                                    
                              </div>

                              <div class="bodyofit">

                                    <div class="flxblack featureitem">Direct interaction with parents </div>
                                    <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                                    <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                                    
                              </div>

                              <div class="bodyofit">

                              <div class="flxblack featureitem">Featured in Trending Now</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>

                              </div>

                              <div class="bodyofit">

                              <div class="flxblack featureitem">Verified partner stamp</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>

                              </div>

                             

                              <div class="bodyofit">

                              <div class="flxblack featureitem">Receive Leads & enquires</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>

                              </div>

                              <div class="bodyofit">

                              <div class="flxblack featureitem">Benchmark to your peers / competitors</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>

                              </div>

                              <div class="bodyofit">

                              <div class="flxblack featureitem">Free benefits of INR 25K+ + from curated partner support</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>

                              </div>
                              <div class="bodyofit">

                              <div class="flxblack featureitem">Ads & newsletter promotion @ special prices </div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>

                              </div>          

                              <div class="bodyofit">
                              <div class="flxblack featureitem">Scope for collaborative & customised services</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span class="fa fa-times"></span></div>
                              </div>          
                              <div class="bodyofit">
                              <div class="flxblack featureitem">Data & analytics to accelerate growth</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span>Partly Free</span></div>
                              </div>          
                              <div class="bodyofit">
                              <div class="flxblack featureitem">Pricing & benefits @ WiseConnect</div>
                              <div class="flxblack planstatus"><span class="fa fa-check"></span></div>
                              <div class="flxblack planstatus"><span>Partly Free</span></div>
                              </div>          
                                  

                              <div class="bodyofit">
                              <div class="flxblack featureitem">*Annual Subscription Fees</div>
                              <div class="flxblack planstatus">
                              <div class="viewpricing">
                                    {this.state.isValuePriceClikedView &&
                                    <span>Rs. 12499/-</span>
                                    }
                                    {!this.state.isValuePriceClikedView &&
                                    <span onClick={this.showValuePrice}>view price</span>
                                    }
                            </div> 

                              </div>
                              <div class="flxblack planstatus">FREE</div>
                              </div> 
                                   

                      </div>
                    

                </div>    

                <div class="colored_centered"> <a href="/individual_signup"  class="btn new-btn-blue-large">Sign Up Now!</a> </div>

                </div>
              }

              </div>
             
              <div class="plan_section desktop">

              <div class="colored_centered">Get <span>Started</span></div>

              <div class="planbox">


              {this.state.schoolpreschoolselected &&
              <div class="newtable">
                    <table width="100%" cellSpacing={2} cellPadding={2} class="__table">
                      <tr>
                          <td width="50%">&nbsp;</td>
                          <td width="15%"><span class="s_plantitle">Standard</span></td>
                          <td  width="15%"><span class="v_plantitle">Magic</span></td>
                          <td  width="20%"><span class="v_plantitle pluswc">Magic+WC</span></td>
                      </tr>                                    
                      <tr class="parent" data-child="audience_with">
                            <td class="plbbolder" width="50%">24x 7 visibility for Target Audience <span class="onclick_expcol"><img src="/images/chevron-down.svg"/></span></td>
                            <td width="15%">&nbsp;</td>
                            <td class="stndtd" width="15%">&nbsp;</td>
                            <td width="20%">&nbsp;</td>
                      </tr>
                      <tr class="child audience_with hidden"><td class="plb" width="50%">Enhanced digital presence</td>
                          <td class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>
                      <tr class="child audience_with hidden"><td class="plb" width="50%">Post your Ad in landing page</td>
                          <td class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>
                      <tr class="child audience_with hidden"><td class="plb" width="50%">Visiblity and respond to review / ratings</td>
                          <td class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>
                      <tr class="child audience_with hidden"><td class="plb" width="50%">Use page as own Web Page in marketing</td>
                          <td class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td  class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr class="child audience_with hidden"><td class="plb" width="50%">Upload Pictures on page</td>
                          <td class="stndtd" width="15%"><span class="plantext">3 Free</span></td>
                          <td  class="stndtd" width="15%"><span class="plantext">Upto 15</span></td>
                          <td class="stndtd" width="20%"><span class="plantext">Upto 15</span></td>
                      </tr>

                      <tr class="child audience_with hidden"><td class="plb" width="50%">Direct interaction with parents </td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr class="child audience_with hidden"><td class="plb" width="50%">Featured in Trending Now</td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr class="child audience_with hidden"><td class="plb" width="50%">Collaborative social media support</td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr class="child audience_with hidden"><td class="plb" width="50%">Verified partner stamp </td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>
                      <tr><td class="plbbolder" width="50%">Receive Leads & enquires </td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr><td class="plbbolder" width="50%">Benchmark to your peers / competitors</td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>
                      <tr><td class="plbbolder" width="50%">Build your brand & thought leadership</td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr><td class="plbbolder" width="50%">Exclusive Benefits from curated partner support</td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="15%">INR 50K++</td>
                          <td class="stndtd" width="20%">INR 50K++</td>
                      </tr>
                      <tr><td class="plbbolder" width="50%">Strengthen brand awareness via exclusive Ads</td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr><td class="plbbolder" width="50%">Data & analytics to accelerate growth </td>
                          <td class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td  class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr>
                          <td class="plbbolder" width="50%">Access to Skill building / self-development </td>
                          <td class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td  class="stndtd" width="15%"><span class="fa fa-check"></span></td>
                          <td class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr>
                          <td class="plbbolder" width="50%">Instant Talent Search and call shortlisted candidates</td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>	
                          <tr>
                          <td class="plbbolder" width="50%">Post Jobs & receive applications from talent </td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>	
                          <tr>
                          <td class="plbbolder" width="50%">Private & direct interaction with candidates / applications </td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>
                          <tr>
                          <td class="plbbolder" width="50%">Full access to Courses / Products / articles @ Portal </td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>	
                          <tr>
                          <td class="plbbolder" width="50%">Full access to all curated benefits from our Partners </td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>	
                          <tr>
                          <td class="plbbolder" width="50%">Available data analytics, reports & benchmarks. </td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>	
                          <tr>
                          <td class="plbbolder" width="50%">Download Resume / CV </td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>
                          <tr>
                          <td class="plbbolder" width="50%">Strengthen brand awareness amongst potential talents</td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>
                      <tr>
                          <td class="plbbolder" width="50%">Avail advisory services</td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>
                          <tr>
                          <td class="plbbolder" width="50%">Nil retainer fees for hiring candidates</td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td class="stndtd" width="15%"><span class="fa fa-times"></span></td>
                          <td  class="stndtd" width="20%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr><td class="plbbolder" width="50%">&nbsp;</td>
                          <td class="stndpricetd" width="15%">
                                <div class="viewpricing">
                                  {this.state.isStandardPriceClikedView1 &&
                                    <span>FREE</span>
                                  }
                                  {!this.state.isStandardPriceClikedView1 &&
                                    <span onClick={this.showStandardPrice1}>view price</span>
                                  }
                                </div>
                          </td>
                          <td  class="valuepricetd" width="15%">
                                <div class="viewpricinginblue">
                                  {this.state.isMagicPriceClikedView &&
                                    <div>
                                      <div><span class="stricken">&#8377; 29999</span><span><b> &#8377; 24999 /- </b><br/><span class="planinfomsg">Annual subscription (BeWise)</span></span></div>
                                    </div>
                                  }
                                  {!this.state.isMagicPriceClikedView &&
                                    <span onClick={this.showMagicPrice}>view price</span>
                                  }
                                </div>

                          </td>
                          <td  class="valuepricetd" width="20%">
                                <div class="viewpricinginblue pluswc">
                                  {this.state.isMagicWcPriceClikedView &&
                                    <div>
                                     <div><span>&#8377; 29999 /- <br/><span class="planinfomsg">Annual subscription (BeWise + WiseConnect)<a href="" class="planinfolink">Benefits of WiseConnect</a></span></span></div>
                                    </div>
                                  }
                                  {!this.state.isMagicWcPriceClikedView &&
                                    <span onClick={this.showMagicWcPrice}>view price</span>
                                  }
                                </div>

                          </td>
                      </tr>

                      

                    </table>                                                    
              </div>  
              }  

             
                                  
              {this.state.otherselected &&
              <div class="newtable">
                    <table width="100%" cellSpacing={2} cellPadding={2}>
                      <tr>
                          <td width="50%">&nbsp;</td>
                          <td width="25%"><span class="s_plantitle">Standard</span></td>
                          <td  width="25%"><span class="v_plantitle">Value</span></td>
                          <td  width="25%"><span class="v_plantitle">Value+WC</span></td>
                      </tr>                                    
                      <tr>
                            <td class="plbbolder" width="50%">24x 7 visibility for Target Audience with</td>
                            <td width="25%">&nbsp;</td>
                            <td class="bluebgtd" width="25%">&nbsp;</td>
                            <td class="bluebgtd" width="25%">&nbsp;</td>
                      </tr>
                      <tr><td class="plb" width="50%">Enhanced digital presence</td>
                          <td class="stndtd" width="25%"><span class="fa fa-check"></span></td>
                          <td class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                          <td class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                      </tr>
                      <tr><td class="plb" width="50%">Visiblity and respond to review / ratings</td>
                          <td class="stndtd" width="25%"><span class="fa fa-check"></span></td>
                          <td class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                          <td class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                      </tr>
                      <tr><td class="plb" width="50%">Use page as own Web Page in marketing</td>
                          <td class="stndtd" width="25%"><span class="fa fa-check"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                          <td class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr><td class="plb" width="50%">Upload Pictures on page</td>
                          <td class="stndtd" width="25%"><span class="plantext">2 Free</span></td>
                          <td  class="bluebgtd" width="25%"><span class="plantext">Upto 10</span></td>
                          <td class="bluebgtd" width="25%"><span class="plantext">Upto 10</span></td>
                      </tr>

                      <tr><td class="plb" width="50%">Direct interaction with parents </td>
                          <td class="stndtd" width="25%"><span class="fa fa-times"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr><td class="plb" width="50%">Featured in Trending Now</td>
                          <td class="stndtd" width="25%"><span class="fa fa-times"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr><td class="plb" width="50%">Verified partner stamp </td>
                          <td class="stndtd" width="25%"><span class="fa fa-times"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                      </tr>
                      <tr><td class="plbbolder" width="50%">Receive Leads & enquires </td>
                          <td class="stndtd" width="25%"><span class="fa fa-times"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr><td class="plbbolder" width="50%">Benchmark to your peers / competitors</td>
                          <td class="stndtd" width="25%"><span class="fa fa-times"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr><td class="plbbolder" width="50%">Exclusive Benefits from curated partner support</td>
                          <td class="stndtd" width="25%"><span class="fa fa-times"></span></td>
                          <td  class="bluebgtd" width="25%">INR 25K++</td>
                          <td  class="bluebgtd" width="25%">INR 25K++</td>
                      </tr>
                      <tr><td class="plbbolder" width="50%">Strengthen brand awareness via exclusive Ads </td>
                          <td class="stndtd" width="25%"><span class="fa fa-times"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr><td class="plbbolder" width="50%">Scope for collaborative & customised services </td>
                          <td class="stndtd" width="25%"><span class="fa fa-times"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                      </tr>

                      <tr><td class="plbbolder" width="50%">Data & analytics to accelerate growth </td>
                          <td class="stndtd" width="25%"><span class="plantext">Partly Free</span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                          <td  class="bluebgtd" width="25%"><span class="fa fa-check"></span></td>
                      </tr>

                      
                      <tr><td class="plbbolder" width="50%">&nbsp;</td>
                          <td class="stndpricetd" width="25%">
                                <div class="viewpricing">
                                  {this.state.isStandardPriceClikedView2 &&
                                    <span>FREE</span>
                                  }
                                  {!this.state.isStandardPriceClikedView2 &&
                                    <span onClick={this.showStandardPrice2}>view price</span>
                                  }
                                </div>
                          </td>
                          <td  class="valuepricetd" width="25%">
                                <div class="viewpricinginblue">
                                  {this.state.isValuePriceClikedView &&
                                    <span>Rs. 12499 /- <br/><span>Annual Subscription Fees</span></span>
                                  }
                                  {!this.state.isValuePriceClikedView &&
                                    <span onClick={this.showValuePrice}>view price</span>
                                  }
                                </div>

                          </td>
                      </tr>

                      

                    </table>                                                    
              </div>  
              }                                  
                       

              {this.state.schoolpreschoolselected &&
                <div class="colored_centered"> <a href="/institution_signup"  class="btn new-btn-blue-large">Sign Up Now!</a> </div>
              }

              {this.state.otherselected &&
                <div class="colored_centered"> <a href="/individual_signup"  class="btn new-btn-blue-large">Sign Up Now!</a> </div>
              }


        </div>

</div>


          </div>
         
        </div>
       
        <Footer />

         
      </React.Fragment >
    );
  }
}

export default NewPartnerInstitutionPage;



// WEBPACK FOOTER //
// ./src/components/2023/new_partner_institutionsv1.jsx